import React from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { isExpired, decodeShortDescription } from "../../../utils/jobHelper";
const AppliedApplicationListItem = (props) => {
  const { t } = useTranslation();
  const { applied, handleSubmitWithdraw, handleSubmitReviewDocument } = props;
  const expired = isExpired(applied.job.jobAdvertExpiryDate);

  return (
    <div className="dashboard-list-item">
      <div className="row">
        <div className="col-xs-12 col-sm-7 col-md-8">
          <div className="row">
            <div className="col-xs-12 col-sm-7">
              <h4>
                <a href={applied.job.jobUrl} title={applied.job.jobTitle}>
                  {applied.job.jobTitle}
                </a>
              </h4>
              <div>#{applied.job.jobReferenceId}</div>
            </div>
            <div className="col-xs-12 col-sm-5 text-right">
              <strong className="black-txt qjicon location-icon">
                {[applied.job.jobState, applied.job.jobCity].join(" - ")}
              </strong>
              <div className="clearfix visible-xs-block">
                <strong className="qjicon time-icon">
                  {expired ? t("Verb.Closed") : t("Verb.Closes")}{" "}
                  {t("ShortDateValue", { date: applied.job.jobAdvertExpiryDate })}
                </strong>
              </div>
            </div>
          </div>
          <div className="row dashboard-list-item--content">
            <div className="col-xs-12 col-sm-8 dark-txt">{decodeShortDescription(applied.job.jobShortDescription)}</div>
            <div className="col-xs-12 col-sm-4 text-right img-wrap">
              {applied.job.jobLogo ? (
                <img className="img-responsive" src={applied.job.jobLogo} alt={applied.job.jobTitle} />
              ) : null}
            </div>
          </div>
        </div>
        <div className="col-xs-12 col-sm-5 col-md-4 dashboard-list-item--side-col">
          <div className="clearfix full-wrap">
            <div>
              {!applied.withdrawnDate ? (
                <strong className="qjicon time-icon">
                  {t("Verb.Applied")} {t("ShortDateValue", { date: applied.createdDate })}
                </strong>
              ) : (
                <strong className="qjicon time-icon">
                  {t("Verb.Withdrawn")} {t("ShortDateValue", { date: applied.withdrawnDate })}
                </strong>
              )}
              <br />
              <br />
              <strong className="qjicon time-icon">
                {expired ? t("Verb.Closed") : t("Verb.Closes")}{" "}
                {t("ShortDateValue", { date: applied.job.jobAdvertExpiryDate })}
              </strong>
              {applied.applicationStatus === 6 ? (
                <div className="clearfix">
                  <OverlayTrigger
                    placement="right"
                    trigger={["click", "hover", "focus"]}
                    overlay={<Tooltip id="adddocument.conditions.exclude">{t("Action.EmployerMoved")}</Tooltip>}>
                    <span style={{ display: "inline", padding: "7px" }}>
                      <i className="glyphicon glyphicon-info-sign" />
                    </span>
                  </OverlayTrigger>
                </div>
              ) : null}
              <br />
              <br />
              {applied.withdrawnDate || applied.applicationStatus === 5 ? null : (
                <div className="clearfix part-wrap part-wrap--button" style={{ padding: "5px" }}>
                  <Button
                    data-testid="handleWithdrawTest"
                    size="sm"
                    variant="primary"
                    onClick={() => handleSubmitWithdraw(applied)}
                    className="mb-2 withdraw-button">
                    {t("Action.Withdraw")}
                  </Button>
                  {applied.isReviewDocumentsReceived && (
                    <Button
                      className="mb-2 review-button"
                      data-testid="handleReviewDocumentsTest"
                      size="sm"
                      variant="success"
                      onClick={() => handleSubmitReviewDocument(applied)}>
                      {t("Action.ReviewDocuments")}
                    </Button>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppliedApplicationListItem;
